import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import BAHeader from './components/BAHeader';
import BAHero from './components/BAHero';
import WorkSamples from './components/WorkSamples';
import ProcessFlow from './components/ProcessFlow';
import Dashboard from './components/Dashboard';
import STARStories from './components/STARStories';
import BASkills from './components/BASkills';
import BAFooter from './components/BAFooter';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <BAHeader />
        <BAHero />
        <WorkSamples />
        <ProcessFlow />
        <Dashboard />
        <STARStories />
        <BASkills />
        <BAFooter />
        <Toaster />
      </div>
    </Router>
  );
}

export default App;